import { cloneElement } from 'react';
import { emotes } from '@/components/EmoteMenu/EmoteMenu';
import { Role } from './kofi-memberships';
import { OAuth2Tokens } from 'arctic';
import { TwitchTokens } from './vodTypes';

export const secondsToTime = (seconds: number): string => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const sec = Math.floor(seconds % 60);

    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSec = sec.toString().padStart(2, '0');

    let timeStr = '';

    if (hours > 0) {
        timeStr += `${formattedHours}:`;
    }

    timeStr += `${formattedMinutes}:${formattedSec}`;

    return timeStr;
};

export const secondsToLongTime = (seconds: number): string => {
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const sec = Math.floor(seconds % 60);

    const components = [];

    if (days > 0) {
        components.push(`${days} ${days === 1 ? 'Tag' : 'Tagen'}`);
    }

    if (hours > 0) {
        components.push(`${hours} ${hours === 1 ? 'Stunde' : 'Stunden'}`);
    }

    if (minutes > 0) {
        components.push(`${minutes} ${minutes === 1 ? 'Minute' : 'Minuten'}`);
    }

    if (sec > 0) {
        components.push(`${sec} ${sec === 1 ? 'Sekunde' : 'Sekunden'}`);
    }

    return components.length > 1 ? `${components.slice(0, -1).join(', ')} und ${components.slice(-1)}` : components[0];
};

export const formatDate = (date: Date): string => date.toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' });

export type RoleMap<T = { title: string; text: string; }> = {
    [role in Role]: T;
};

export const roleToString: RoleMap = {
    admin: { title: 'Administrator', text: '👑' },
    kofiDiamond: { title: 'Ko-fi Diamant', text: '💎' },
    kofiGold: { title: 'Ko-fi Gold', text: '🥇' },
    kofiSilver: { title: 'Ko-fi Silver', text: '🥈' },
    kofiBronze: { title: 'Ko-fi Bronze', text: '🥉' },
    kofiPayWhatYouWant: { title: 'Ko-fi Pay What You Want', text: '💗' },
    twitchTier1: { title: 'Twitch Tier 1', text: 'T1' },
    twitchTier2: { title: 'Twitch Tier 2', text: 'T2' },
    twitchTier3: { title: 'Twitch Tier 3', text: 'T3' },
};

export const replaceEmotes = (inputString: string, emoteMap: typeof emotes) => {
    const result: (string | React.JSX.Element)[] = [];

    const words = inputString.split(' ');
    words.forEach((word, idx) => {
        if (Object.keys(emoteMap).includes(word.trim())) {
            const ele = emoteMap[word.trim() as keyof typeof emoteMap];
            result.push(cloneElement(ele, { key: `${word}-${idx}` }));
        } else {
            result.push(word, ' ');
        }
    });

    return result;
};